import Logo from 'components/Logo';
import './styles.scss';
import HeaderNavigation from './Navigation';
import CountrySelector from 'components/HeaderNew/CountrySelector';
import Search from './Search';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsCountryOpen, selectIsNavigationItemHover, setCountryOpen } from 'store/slices/UI-Slice';
import { useLocation } from 'react-router-dom';
import DetermineCountryPopup from 'components/DetermineCountryPopup';

const BurgerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="40" viewBox="0 0 56 40" fill="none">
        <line x1="16" y1="15.25" x2="41" y2="15.25" stroke="white" strokeWidth="1.5" />
        <line x1="16" y1="23.25" x2="41" y2="23.25" stroke="white" strokeWidth="1.5" />
    </svg>
);

const HeaderNew = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const isCountryOpen = useSelector(selectIsCountryOpen);
    const [mobileMenuIsOpen, setMobileMenuOpen] = React.useState(false);
    const [isSearchOpen, setSearchOpen] = React.useState(false);

    const onToggleMobileMenu = () => setMobileMenuOpen(!mobileMenuIsOpen);
    const isNavigationItemHover = useSelector(selectIsNavigationItemHover);

    React.useEffect(() => {
        setMobileMenuOpen(false);
    }, [location]);

    React.useEffect(() => {
        if (isSearchOpen) {
            dispatch(setCountryOpen(false));
            setMobileMenuOpen(false);
        }
    }, [isSearchOpen]);

    React.useEffect(() => {
        if (isCountryOpen) {
            setSearchOpen(false);
            setMobileMenuOpen(false);
        }
    }, [isCountryOpen]);

    React.useEffect(() => {
        if (isNavigationItemHover) {
            setSearchOpen(false);
            dispatch(setCountryOpen(false));
        }
    }, [isNavigationItemHover]);

    React.useEffect(() => {
        if (mobileMenuIsOpen) {
            setSearchOpen(false);
            dispatch(setCountryOpen(false));
        }
    }, [mobileMenuIsOpen]);

    return (
        <>
            {mobileMenuIsOpen ? <div className="overlay" onClick={onToggleMobileMenu} /> : false}
            <header>
                <div className="container">
                    <div className={`header ${mobileMenuIsOpen ? 'mobile-menu-isOpen' : ''}`}>
                        <div className="header__main">
                            <div className="header-logo">
                                <Logo />
                            </div>
                            <HeaderNavigation />
                            <div className="header-finish">
                                <DetermineCountryPopup />
                                <CountrySelector />
                                <Search isOpen={isSearchOpen} setIsOpen={setSearchOpen} />
                                <button className="burger-button" onClick={onToggleMobileMenu}>
                                    <BurgerIcon />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default HeaderNew;
